/* tslint:disable: no-duplicate-string */

import Dexie from 'dexie';
import { Injectable } from '@angular/core';
import { DocumentDownloadSelection } from '@app/core/model/document-download';

export interface WorkOrderItem {
  workOrderId: string;
  workCenterId: string;
  projectId: string;
  lastUpdated: Date;
  // Not indexed, so no schema version bump needed. Null/absent = all documents.
  documentSelection?: DocumentDownloadSelection | null;
}

export interface WorkOrderDataItem {
  workOrderId: string;
  type: string;
  data: any;
}

export interface WorkOrderFile {
  workOrderId: string;
  url: string;
  // ArrayBuffer, not Blob: WebKit/Safari can fail to structured-clone Blobs into IndexedDB.
  data: ArrayBuffer;
  type?: string;
}

@Injectable({
  providedIn: 'root',
})
export class OfflineDataDb {
  workOrders: Dexie.Table<WorkOrderItem>;
  workOrderDataItems: Dexie.Table<WorkOrderDataItem>;
  workOrderFiles: Dexie.Table<WorkOrderFile>;

  constructor() {
    const db = new Dexie('offline-data');
    db.version(1).stores({
      workOrders: 'workOrderId,[workCenterId+projectId]',
      workOrderDataItems: '[workOrderId+type],workOrderId',
    });

    db.version(2).stores({
      workOrders: 'workOrderId,[workCenterId+projectId]',
      workOrderDataItems: '[workOrderId+type],workOrderId,type',
    });

    db.version(3).stores({
      workOrders: 'workOrderId,[workCenterId+projectId]',
      workOrderDataItems: '[workOrderId+type],workOrderId,type',
      workOrderFiles: '[workOrderId+url],workOrderId,url',
    });

    this.workOrders = db.table('workOrders');
    this.workOrderDataItems = db.table('workOrderDataItems');
    this.workOrderFiles = db.table('workOrderFiles');
  }
}
